import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { validateEmail, resetWeights, calculateWeights, setupLocalStorage, appendToLocalStorage } from '../Functions';
import { Store, Weights } from '../Store';
import { Questions } from '../Data';
import { Svgs } from '../components/Svgs';

class ResultsForm extends Component {

  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.seeResults = this.seeResults.bind(this);

    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      company: '',
      emailValid: false,
      recomendations: null,
      questions: Questions,
      store: Store
    }
  }

  componentDidMount() {

    document.querySelector('.app').classList.add('screen--results');
    this.dom = ReactDOM.findDOMNode(this);
    void this.dom.offsetWidth;
    this.dom.classList.add('results--animate-in');
    this.setSolutions();
    window.scrollTo(0,0);

  }

  componentWillUnmount() {
    document.querySelector('.app').classList.remove('screen--results');
  }

  handleInputChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
    if (e.target.name === 'email') {
      
      if (validateEmail(e.target.value)) {
        this.setState({emailValid: true});
      } else {
        this.setState({emailValid: false});
      }
    }
  }

  seeResults = (e, history) => {

    let self = this;

    self.props.overlayToggle(true);

    if (this.props.connectionStatus === 'online') {

      // if we're online
      fetch('/email', {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(self.state)
      })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        }
        return res;
      })
      .then(res => {
        self.props.overlayMessage({
          copy: 'Email succesfully sent.'
        });
        setTimeout(() => {
          self.props.overlayToggle(false);
        }, 2500);
        setTimeout(() => {
          history.push('/results-recommendations');
        }, 3500);
        
      }).catch(function(error) {
        console.log(error);
        self.props.overlayMessage({
          copy: 'Failed to send. We will try and send you an email at a later date.'
        });

        // failed to send so save is local storage
        setupLocalStorage();
        appendToLocalStorage(self.state);

        setTimeout(() => {
          self.props.overlayToggle(false);
          history.push('/results-recommendations');
        }, 2500);
      });

    } else {

      // if we're offline
      self.props.overlayMessage({
        copy: 'You are currently offline. We will try and send you an email when you come back online.'
      });

      // we're offline so save it to local storage
      setupLocalStorage();
      appendToLocalStorage(self.state);

      setTimeout(() => {
        self.props.overlayToggle(false);
        history.push('/results-recommendations');
      }, 2500);

    }

  }

  setSolutions(){

    resetWeights();
    calculateWeights();

    this.setState({
      recomendations: Weights
    });

  }
  
  render() {
    const history = this.props.history;
    let disableSeeButton = true;
    if (this.state.firstName && this.state.lastName && this.state.emailValid && this.state.company) {
      disableSeeButton = false;
    }
    return (
      <div className="results">
        <h1>Results.</h1>
        <p>Let us know where we can send some more information on the relevant products for you.</p>
        <form>
          <ul>
            <li><input placeholder="First name*" name="firstName" type="text" value={this.state.firstName} onChange={this.handleInputChange} /></li>
            <li><input placeholder="Last name*" name="lastName" type="text" value={this.state.lastName} onChange={this.handleInputChange} /></li>
            <li><input placeholder="Email*" name="email" type="email" value={this.state.email} onChange={this.handleInputChange} /></li>
            <li><input placeholder="Company*" name="company" type="text" value={this.state.company} onChange={this.handleInputChange} /></li>
            <li><button type="button" onClick={(e) => this.seeResults(e, history)} className="btn btn--solid-red" disabled={disableSeeButton}><span>See results</span> <Svgs width="8" height="8" svg="RightChevron" /></button></li>
          </ul>
        </form>
      </div>
    );
  }
}

export default ResultsForm;



// WEBPACK FOOTER //
// ./src/screens/ResultsForm.js